export default {
  methods: {
    async getMyPhotosAI (tabActive) {
      this.loading = true

      try {
        console.log('tabActive', tabActive)
        console.log('Inside getMyPhotosAI')
        let response
        if (tabActive === 'myPhotos') {
          if (this.selfie._id) {
            response = await this.$axios.get(`/image/bySelfieId/detectedAi/${this.event._id}/${this.selfie._id}`)
          }
        } else {
          response = await this.$axios.get(`image/event/${this.event._id}`)
        }
        console.log('response.data', response.data)
        if (tabActive === 'myPhotos') this.$store.commit('event/SET_MY_AI_PHOTOS', response.data.images)
        else this.$store.commit('event/SET_ALL_PHOTOS', response.data.images)
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log('Error in getMyPhotosAI', e)
      }
    }
  }
}
